module.exports = "<pplus-meter-consumed></pplus-meter-consumed>\r\n"